Ext.ns('mx.userRole');

mx.userRole.UsersRoleControl = Ext.extend(Ext.form.FieldSet, {
    checkboxToggle: true,
    collapsed: true,
    title: 'Empty role',
    name: 'role',
    autoHeight: false,
    layout: 'mx-form',
    userId: -1,
    originalValue: null,
    position: 0,
    readOnly: false,
    labels: {},
    onExpand: function(doAnim, animArg) {
        mx.userRole.UsersRoleControl.superclass.onExpand.call(this, doAnim, animArg);
        if (this.items.length == 0) {
            Ext.form.FieldSet.superclass.onCollapse.call(this, doAnim, animArg);
        }
    },
    initComponent: function() {
        mx.userRole.UsersRoleControl.superclass.initComponent.call(this);
        this.on(
            'afterlayout',
            function() {
                if (this.readOnly) {
                    Ext.fly(this.el)
                        .select('input,select,a,button')
                        .each(function(el) {
                            if (!el.dom.disabled) {
                                el.dom.disabled = true;
                            }
                        });
                }
            },
            this
        );
    },
    setId: function(value) {
        this.userId = value;
    },
    validate: function() {},
    setValue: function(value) {
        this.originalValue = !!value;
        if (value) {
            this.expand();
        } else {
            this.collapse();
        }
    },
    getName: function() {
        return this.name;
    },
    getValue: function() {
        if (this.checkbox) {
            return !!this.checkbox.dom.checked;
        }
        return false;
    },
});
